import React, { useEffect } from "react";
import { Object3D } from "three";
import { ref } from "valtio";
import { cameraStore } from "../../appStore";

interface SetCameraTargetProps {
  settingsObject: Object3D;
}

const SetCameraTarget: React.FC<SetCameraTargetProps> = ({ settingsObject, ...props }) => {
  useEffect(() => {
    cameraStore.cameraTargetSettings = ref(settingsObject);
  }, []);
  return null;
};

export default SetCameraTarget;
